const $pagebanner = document.getElementById('pageBanner');

function close() {
  $pagebanner.classList.remove('pageBanner--show');
  sessionStorage.setItem('closedPageBanner', true);
  setTimeout(() => {
    $pagebanner.style.display = 'none';
  }, 1000);
}

function init() {
  if ($pagebanner) {
    document.querySelector('.js-pageBanner__close').addEventListener('click', close);
  }
}

export { init };
